<template>
  <div id="app">
    <keep-alive>
		<router-view v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>
	<router-view v-if="!$route.meta.keepAlive" />
    <!-- <router-view></router-view> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
import './assets/style/common.css';
export default {
  name: 'app',
  data(){
     return{
     }
  },
  beforeCreate()
  {
    
  },
  created(){

    
    
    // var isload=localStorage.getItem("isloadfirst");
    // if(!isload)
    // {
      
    // }
    // setTimeout(() => {
    //   this.vshow=false;
    // }, 3000);
  },
  methods:{
    
  }
}
</script>


